module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t公司名称：\n\t\t\t"), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "cp_company_id", $$v)
      },
      expression: "pdata.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t 结算期：\n\t\t\t"), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "format": "yyyyMM",
      "value-format": "yyyyMM",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.d_date),
      callback: function($$v) {
        _vm.d_date = $$v
      },
      expression: "d_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t 分成方式：  \n\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择账单类型"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.bill_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "bill_type", $$v)
      },
      expression: "pdata.bill_type"
    }
  }, [_c('el-option', {
    key: "0",
    attrs: {
      "label": "汇总",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "1",
    attrs: {
      "label": "原生分成账单",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "利润分成账单",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "icon": "el-icon-download",
      "type": "primary"
    },
    on: {
      "click": _vm.getBillList
    }
  }, [_vm._v("导出预览")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "结算周期",
      "min-width": "140px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t" + _vm._s(scope.row.sdate) + "~" + _vm._s(scope.row.edate) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost",
      "label": "结算金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t￥" + _vm._s(scope.row.total_cost) + "\n\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push('/billCpData/summary/' + scope.row.cp_company_id + '?sdate=' + scope.row.sdate + '&edate=' + scope.row.edate)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分成账单统计",
      "visible": _vm.billDialog,
      "width": "900px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm"
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "900px"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "33%"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('td', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "3",
      "rowspan": "1"
    }
  }, [(_vm.pdata.bill_type == 0) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("汇总分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 1) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("原生分成统计")]) : _vm._e(), _vm._v(" "), (_vm.pdata.bill_type == 2) ? _c('div', {
    staticClass: "cell"
  }, [_vm._v("利润分成统计")]) : _vm._e()])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("公司名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算金额")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.sdate) + "~" + _vm._s(item.edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.company_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v("￥" + _vm._s(item.total_cost))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_29 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t合计\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_30 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t-\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_31 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "1"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t￥" + _vm._s(_vm.total.total_cost) + "\n\t\t\t\t\t\t\t\t")])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleDown
    }
  }, [_vm._v("导出pdf")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2af97c1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cp/statisticsList.vue
// module id = 1124
// module chunks = 2